import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';

export const VirtualGatewayDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.syncVirtualGateway',
        popover: {
          title: 'Sync Virtual Gateway Information',
          description:
            'Click here to sync the latest data from the virtual gateway. This action will ensure that the displayed information is up-to-date, including any changes to its state, IP addresses, and network configuration.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.retireVirtualGateway',
        popover: {
          title: 'Retire Virtual Gateway',
          description:
            'Click here to retire the virtual gateway. Retiring a gateway marks it as inactive, but it will retain its configuration and logs for future reference. This action is useful when you no longer wish to actively use the gateway.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createVirtualGateway',
        popover: {
          title: 'Create New Virtual Gateway',
          description:
            'Click this button to create a new virtual gateway. You will need to specify the **Name**, **Description**, select the **Region**, and assign it to the appropriate **Public Network IP** for external communication. Additionally, choose a **Private Network** if needed.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.tableDataVirtualGateway',
        popover: {
          title: 'Virtual Gateway Resources Overview',
          description:
            'This table shows a comprehensive overview of your virtual gateways, including **Name**, **Description**, **Public Network IP**, and **State**. Use this table to monitor and manage the health and status of your virtual gateways.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};

export default VirtualGatewayDriverObj;
